import { Theme } from '@mui/material/styles'
import { IconButtonProps } from '@mui/material/IconButton'

import { onHover } from '../interaction'

// ----------------------------------------------------------------------

/**
 * There was no IconButton override at all, so every icon button in the app took
 * MUI's default hover — `alpha(palette[color].main, hoverOpacity)` for a colour
 * prop, `alpha(action.active, hoverOpacity)` otherwise. Two icon buttons side by
 * side in one toolbar therefore hovered two different colours depending on a prop
 * that was usually chosen for the icon's *resting* tint.
 *
 * Chrome (default / inherit / primary / secondary) takes the neutral wash.
 * info / success / warning / error keep their tint: on an icon-only control the
 * hover tint is often the only thing naming the action, and a delete button has
 * to keep reading as destructive.
 */
export default function IconButton(theme: Theme) {
  const CHROME = ['default', 'inherit', 'primary', 'secondary']

  return {
    MuiIconButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: IconButtonProps }) => ({
          ...(CHROME.includes(ownerState.color ?? 'default') &&
            onHover({ backgroundColor: theme.palette.action.hover })),
        }),
      },
    },
  }
}
